(function () {
  let popularProductsSwiper;

  const initSlider = (slider) => {
    slider.classList.add("swiper");

    const wrapper = slider.querySelector(".popular-products__wrapper");

    if (!wrapper) return;

    wrapper.classList.add("swiper-wrapper");

    const slides = slider.querySelectorAll(
      ".popular-products__item, .popular-products__item_placeholder"
    );

    if (!slides || !slides.length) return;

    slides.forEach((slide) => {
      slide.classList.add("swiper-slide");
    });

    const navigation = slider.parentElement.querySelector(
      ".popular-products__navigation"
    );

    const desktopProductsToShow =
      parseInt(slider.dataset.desktopProductsToShow) || 4;

    const swiperConfig = {
      loop: false,
      slidesPerView: 2,
      spaceBetween: 16,
      speed: 1000,
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        320: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        765: {
          slidesPerView: 5,
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: Math.min(desktopProductsToShow, 5),
          spaceBetween: 24,
        },
      },
    };

    if (navigation) {
      swiperConfig.navigation = {
        nextEl: navigation.querySelector(".swiper-button-next"),
        prevEl: navigation.querySelector(".swiper-button-prev"),
      };
    }

    popularProductsSwiper = new Swiper(slider, swiperConfig);
  };

  const destroySlider = (section) => {
    if (!section || !section?.classList.contains("popular-products-section"))
      return;

    const slider = section.querySelector(".popular-products-slider");
    const slides = section.querySelectorAll(
      ".popular-products__item, .popular-products__item_placeholder"
    );
    const wrapper = section.querySelector(".popular-products__wrapper");

    if (!slider || !slides || !slides.length || !wrapper) return;

    slider.classList.remove("swiper");

    slides.forEach((slide) => {
      slide.classList.remove("swiper-slide");
    });

    wrapper.classList.remove("swiper-wrapper");

    popularProductsSwiper.destroy(true, true);
    popularProductsSwiper = null;
  };

  const initPopularProducts = (section) => {
    if (!section || !section?.classList.contains("popular-products-section"))
      return;

    const slider = section.querySelector(".popular-products-slider");

    if (!slider) return;

    const mobileSliderEnabled = slider.dataset.mobileSlider === "true";
    const desktopSliderEnabled = slider.dataset.desktopSlider === "true";

    const sectionResizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const isMobile = entry.contentRect.width < 576;
        const shouldInit =
          (isMobile && mobileSliderEnabled) ||
          (!isMobile && desktopSliderEnabled);

        if (shouldInit && !popularProductsSwiper) {
          initSlider(slider);
        } else if (!shouldInit && popularProductsSwiper) {
          destroySlider(section);
        }
      });
    });

    sectionResizeObserver.observe(section);
  };

  if (popularProductsSwiper) {
    destroySlider(document.currentScript.parentElement);
  }

  initPopularProducts(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (e) {
    if (popularProductsSwiper) {
      destroySlider(e.target);
    }

    initPopularProducts(e.target);
  });
})();
